//If the provided value is formatted like a UTC DateTime(2021-10-01T16:21:33Z), we format the date to 10/01/2021, 11:21 AM
//In all other cases the original value is returned
export const parseUtcDate = (value) => {
    const utcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
    const regResponse = utcRegex.exec(value);

    if (regResponse) {
        const dateTime = new Date(value);

        return dateTime.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' });
    } else {
        return value;
    }
};

//Checks to see if a DateTime is set to exactly midnight. This is used to help handle dates generated with default times set to midnight.
export function isMidnightDateTime(dateString) {
    const date = new Date(dateString);

    const hours = date.getUTCHours();
    const mins = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return (hours + mins + seconds) == 0;
}
